import React from 'react';
import ScopesFormatter from './ScopesFormatter';

export const scopesFormatter = cell => <ScopesFormatter scopes={cell} />;

export default scopesFormatter;
